import React from "react";
import "./styles.less";

export const Link = (props) => {
  const { children, iconSize, ...restProps } = props;
  return (
    <div className="authing-link-icon-warp">
      <a className="authing-link-icon" {...restProps}>
        <span className="authing-link-text">{children}</span>
        <i
          className="icon authing-icon authing-a-arrow-right-line3 icon-style"
          style={{
            display: "inline-block",
            // transform: "rotate(90deg)",
            marginLeft: 6,
            color: "inherit",
            fontSize: iconSize ? iconSize : "inherit",
          }}
        ></i>
      </a>
    </div>
  );
};
